var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnlocked(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "20px",
    viewBox: "0 0 13 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 7@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "All-Icons",
    transform: "translate(-175.000000, -141.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(175.000000, 142.450194)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.058763,7.26129367 L1.94190135,7.26054154 L0.511514382,7.26054154 C0.229163172,7.26054154 0.000718384463,7.49411475 0.000718384463,7.78276249 L0,17.7418712 C0,18.0305377 0.22846318,18.2640921 0.510795998,18.2640921 L12.489204,18.2640921 C12.7715552,18.2640921 13,18.0305189 13,17.7418712 L13,7.78351462 C13,7.49484807 12.7715368,7.26129367 12.489204,7.26129367 L11.058763,7.26129367 Z M11.9784091,17.2196502 L1.02240234,17.2196502 L1.02240234,8.30581078 L11.9784091,8.30581078 L11.9784091,17.2196502 Z M5.9896649,13.567695 L5.9896649,15.3363605 C5.9896649,15.625027 6.21812808,15.8585814 6.5004609,15.8585814 C6.78279372,15.8585814 7.0112569,15.6250082 7.0112569,15.3363605 L7.0112569,13.567695 C7.83530236,13.3377884 8.44309681,12.5665756 8.44309681,11.6520262 C8.44309681,10.5568909 7.57163724,9.66603342 6.50055286,9.66603342 C5.42946848,9.66603342 4.5580089,10.5569849 4.5580089,11.6520262 C4.5580089,12.5664816 5.16580335,13.3376944 5.98984882,13.567695 L5.9896649,13.567695 Z M6.5004609,10.7113027 C7.00838777,10.7113027 7.42076915,11.1336411 7.42076915,11.6521954 C7.42076915,12.1714831 7.00767049,12.5930881 6.5004609,12.5930881 C5.99253402,12.5930881 5.58015265,12.1707497 5.58015265,11.6521954 C5.58015265,11.1329077 5.99253402,10.7113027 6.5004609,10.7113027 Z",
    id: "Shape",
    fill: "#B7844D",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(5.819242, 4.261622) rotate(-25.000000) translate(-5.819242, -4.261622) translate(1.695319, 1.482459)",
    stroke: "#B7844D"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path-12",
    transform: "translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.65208293e-13,4.88631429 C0.117796508,4.83053751 0.178046984,4.70132995 0.180751428,4.4986916 C0.186781998,4.04683362 0.201266296,3.70382303 0.224204322,3.46965982 C0.317556904,2.51666851 0.523614722,1.84967435 0.842377774,1.46867734 C1.53804288,0.637193506 2.59111068,-1.6232143e-13 4.24784543,-1.6232143e-13",
    id: "Path-11"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4.18005745,5.5583256 C4.10632308,3.44777603 4.32709652,2.08455994 4.84237777,1.46867734 C5.53804288,0.637193506 6.59111068,-1.00676419e-13 8.24784543,-1.00676419e-13",
    id: "Path-11",
    transform: "translate(6.207029, 2.779163) scale(-1, 1) translate(-6.207029, -2.779163) "
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlocked);
export default __webpack_public_path__ + "static/media/Unlocked.dc8c8068c1b71f1e78fbbf4c0e709e6b.svg";
export { ForwardRef as ReactComponent };